// API Constants

// API endpoints
export const API_ENDPOINTS = {
	AUTH: {
		// These endpoints are still used - not migrated to Server Actions yet
		SEND_CONFIRMATION: "/api/auth/send-confirmation",
		VERIFY: "/api/auth/verify",
	},
	FESTIVALS: {
		ATTENDANCE_FACEPILE: "/api/festivals/attendance-facepile",
		SOCIAL_INTERACTIONS: (slug: string) =>
			`/api/festivals/${slug}/social-interactions`,
	},
	SEARCH: "/api/search",
} as const;

// HTTP status codes we handle
export const HTTP_STATUS = {
	OK: 200,
	CREATED: 201,
	BAD_REQUEST: 400,
	UNAUTHORIZED: 401,
	FORBIDDEN: 403,
	NOT_FOUND: 404,
	CONFLICT: 409,
	INTERNAL_ERROR: 500,
} as const;

// HTTP methods
export const HTTP_METHODS = {
	GET: "GET",
	POST: "POST",
	PATCH: "PATCH",
	PUT: "PUT",
	DELETE: "DELETE",
} as const;

export type HttpMethod = (typeof HTTP_METHODS)[keyof typeof HTTP_METHODS];

// Request limits and timeouts
export const API_LIMITS = {
	DEFAULT_PAGE_SIZE: 20,
	MAX_PAGE_SIZE: 100,
	DEFAULT_TIMEOUT: 10000,
	UPLOAD_MAX_SIZE: 5 * 1024 * 1024, // 5MB
	RATE_LIMIT_REQUESTS: 100,
	RATE_LIMIT_WINDOW: 60 * 1000, // 1 minute
} as const;
